import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const TimerCroutonTimerBox = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    border: "1px solid #ffffff15",
    height: theme.spacing.xLarge,
    borderRadius: theme.spacing.xSmall,
    padding: `${theme.spacing.xxSmall} ${theme.spacing.xSmall} ${theme.spacing.xxxSmall} ${theme.spacing.xSmall}`,
    marginRight: theme.spacing.small,
}));

export const TimerCroutonTimerText = styled(Text)(() => ({
    display: "flex",
}));
